import { useFormContext } from "react-hook-form";
import useEvent from "react-use-event-hook";

import {
  BOOKING_BULK_FORM_FIELDS,
  IDropdownItem,
  IDropdownItemExt,
  Log,
} from "@ryde/shared";

export const useBulkBookingForm = () => {
  const { setValue } = useFormContext();

  const onShiftSelect = useEvent((shift?: IDropdownItem) => {
    Log.debug("onShiftSelect event, shift:", shift);

    if (shift) {
      setValue(
        BOOKING_BULK_FORM_FIELDS.arrivalTime,
        (shift as IDropdownItemExt).shiftStartTime ?? "",
      );
      setValue(
        BOOKING_BULK_FORM_FIELDS.departureTime,
        (shift as IDropdownItemExt).shiftEndTime ?? "",
      );
    }
  });

  return {
    onShiftSelect,
  };
};
